import * as Html from "../util/Html.ts";
export {initDom}

Html.registerWidget('widget/rotateonclick',{initDom})

function initDom(o: HTMLElement){
  o.style.transformOrigin = "50% 50%";
  o.style.transition = "all 1.2s";

  o.addEventListener('click', function(){
    let angle = parseInt(o.dataset.angle || '0');
    angle += 360;
    o.dataset.angle = angle.toString();
    o.style.transform = `rotate(${angle}deg)`;
  });
}